import type {Client} from '@bugsnag/js'
import isNil from 'lodash/isNil'
import type {
  BugsnagEventT,
  ErrorContext,
} from '@freckle/educator-entities/ts/common/helpers/exception-handlers/bugsnag-helper'
import BugsnagHelper from '@freckle/educator-entities/ts/common/helpers/exception-handlers/bugsnag-helper'
import {getEnvironment} from '@freckle/educator-entities/ts/config/environment'
import {Globals} from '@freckle/classroom/ts/common/models/globals'

function initBugsnag(): Client | undefined {
  const environment = getEnvironment(window.location.hostname)

  if (environment === 'localhost') return

  return BugsnagHelper.init(
    (): ErrorContext => ({
      user: !isNil(Globals.userId) ? {id: Globals.userId} : undefined,
    }),
  )
}

export const bugsnagClient: Client | undefined = initBugsnag()

export function logError(err: Error, onError?: (event: BugsnagEventT) => void) {
  if (bugsnagClient !== undefined) BugsnagHelper.logError(err, onError)
  else console.log('Would send to Bugsnag:', err)
}

export function logErrorAsUnhandled(err: Error) {
  if (bugsnagClient !== undefined) BugsnagHelper.logErrorAsUnhandled(err)
  else console.log('Would send to Bugsnag as unhandled', err)
}
